import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Grid } from '@mui/material';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { FormSectionCard } from 'components/_basic/FormSectionCard';

import { concatWithDot } from 'helpers/string';

import { IEstimatedTaxRateSectionProps } from './types';
import { prefix, PROFIT_AND_LOSS_PROJECTION_FORM_NAMES } from '../../utils/form';

export const EstimatedTaxRateSection: FC<IEstimatedTaxRateSectionProps> = ({ title, disabled }) => {
  const { control } = useFormContext();

  const fieldName = concatWithDot(prefix, PROFIT_AND_LOSS_PROJECTION_FORM_NAMES.ESTIMATED_TAX_RATE);

  return (
    <FormSectionCard title={title} disabled={disabled}>
      <Grid container>
        <Grid item xs={6}>
          <NumberInputControlled
            control={control}
            name={fieldName}
            id={fieldName}
            adornmentType="percentage"
            disabled={disabled}
            maxValue={100}
          />
        </Grid>
      </Grid>
    </FormSectionCard>
  );
};
